"use client";

import React from "react";
import { Building2, Users, HeartHandshake, Globe } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Businesses",
  description: "Save time and resources by connecting with a pre-vetted pool of qualified caregiving professionals ready to work.",
  icon: Building2
}, {
  title: "Workforce",
  description: "Increasing the pool of available opportunities with flexible scheduling and meaningful career pathways.",
  icon: Users
}, {
  title: "Customers",
  description: "Help from qualified, compassionate caregivers ensuring the highest standard of care for your loved ones.",
  icon: HeartHandshake
}, {
  title: "Community",
  description: "Caregiving jobs are the backbone of our community, and we're dedicated to supporting this vital ecosystem.",
  icon: Globe
}];
export default function AlliloopBuildsBridgesAcrossTheCareEconomy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="alliloop-bridges" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold leading-[1.4] md:leading-[1.5] tracking-tight">
            Alliloop Builds Bridges Across the Care Economy
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-card border border-transparent p-8 flex flex-col gap-0 transition-all duration-300 ease-out hover:-translate-y-2 hover:border-primary/50 hover:shadow-[0_0_25px_-5px_var(--color-primary)] hover:shadow-primary/20 group">
                  <div className="mb-8">
                    <Icon className="size-8 text-foreground transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}